import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { checkIfPathExistsForLanguage } from '../../helpers/check-if-path-exists-for-language';
import { translateRawPaths } from '../../helpers/translate-raw-paths';
import { LanguageService } from '../../../services';

@Injectable({
	providedIn: 'root',
})
export class TranslatedRouteGuard {
	private readonly router = inject(Router);
	private readonly languageService = inject(LanguageService);

	public canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
		return this.languageService.selectedLanguage$.pipe(
			first(),
			map((language) => {
				const areAllSegmentsInCurrentLanguage = route.url.every((segment) => {
					return checkIfPathExistsForLanguage(segment.path, language);
				});

				if (areAllSegmentsInCurrentLanguage) {
					return true;
				}

				const allSegments = route.pathFromRoot.flatMap(({ url }) => url);
				const paths = translateRawPaths(
					allSegments.map(({ path }) => path),
					language
				);

				return this.router.createUrlTree(paths, {
					queryParams: route.queryParams,
					fragment: route.fragment ?? undefined,
				});
			})
		);
	}
}
